import { render, staticRenderFns } from "./HcButtonSvg.vue?vue&type=template&id=17f34785&scoped=true&"
import script from "./HcButtonSvg.vue?vue&type=script&lang=js&"
export * from "./HcButtonSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f34785",
  null
  
)

export default component.exports